import { render } from "./Smtp.vue?vue&type=template&id=7cc9058a"
import script from "./Smtp.vue?vue&type=script&lang=js"
export * from "./Smtp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/MERCANTIL/helpdesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__